import script from "./NavButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./NavButtons.vue?vue&type=script&setup=true&lang=js"

import "./NavButtons.vue?vue&type=style&index=0&id=0d3559a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3559a4"]])

export default __exports__